import { memo, ReactNode } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

export const TVFocusable = memo(
  ({
    children,
    style,
    onPress,
  }: {
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
    children?: ReactNode;
  }) => {
    return (
      <TouchableOpacity style={style} onPress={onPress}>
        {children}
      </TouchableOpacity>
    );
  },
);
